const general = {
	elements: {
		$document:  $(document),
		$body:      $('body'),
		devUtility: $('.js-dev-utility'),
	},

	init() {
		this.initEvents()
	},

	initEvents() {
		this.handleResize()

		window.addEventListener('resize', () => {
			this.handleResize()
		})
	},

	handleResize() {
		this.elements.$body.css('--window-width', window.innerWidth)
		window.vh = this.elements.devUtility.height() / 100
		this.elements.$body.css('--vh', window.vh)

		window.isMobile = window.innerWidth < 768
	},
}

export default general
